// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13czc","label":"styles_label__3b_bJ"};